<div class="controls-container">
    <div class="controls-header">Tabs</div>
    <div class="controls-sub-header">Tabs Default</div>
    <pm-tabs>
        <pm-tab Name="Tab 1">
            <div class="home-welcome-section">
                <div class="controls-header">Welcome</div>
                <div class="controls-sub-header"><pm-link Href="https://github.com/claygifford/pm-controls"><a class="link" href="https://github.com/claygifford/pm-controls">https://github.com/claygifford/pm-controls</a></pm-link></div>
            </div>
        </pm-tab>
        <pm-tab Name="Tab 2">
            <div class="home-welcome-section">
                <pm-button>Goto</pm-button>
            </div>
        </pm-tab>
    </pm-tabs>

    <div class="controls-sub-header">Tabs Theme 1</div>
    <pm-tabs TabsClass="tabs-theme-1">
        <pm-tab Name="Tab 1">
            <div>
                <div class="controls-header">Welcome</div>
                <div class="controls-sub-header">
                    <pm-link Href="https://github.com/claygifford/pm-controls">
                        <a class="link"
                            href="https://github.com/claygifford/pm-controls">https://github.com/claygifford/pm-controls</a>
                    </pm-link>
                </div>
            </div>
        </pm-tab>
        <pm-tab Name="Tab 2">
            <div>
                <pm-button>Goto</pm-button>
            </div>
        </pm-tab>
    </pm-tabs>

    <div class="controls-sub-header">Tabs Theme 2</div>
    <pm-tabs TabsClass="tabs-theme-2">
        <pm-tab Name="Tab 1">
            <div>
                <div class="controls-header">Welcome</div>
                <div class="controls-sub-header">
                    <pm-link Href="https://github.com/claygifford/pm-controls">
                        <a class="link"
                            href="https://github.com/claygifford/pm-controls">https://github.com/claygifford/pm-controls</a>
                    </pm-link>
                </div>
            </div>
        </pm-tab>
        <pm-tab Name="Tab 2">
            <div>
                <pm-button>Goto</pm-button>
            </div>
        </pm-tab>
    </pm-tabs>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/tabs/tabs.html